import { number, object, string } from 'yup';
import i18n from 'i18next';

export const schema = object().shape({
  company: string()
    .required(i18n.t('common.fieldRequiredMessage'))
    .test('len', i18n.t('Please enter atleast 4 characters.'), (val) => val && val.length > 3)
    .test('len', i18n.t('Please enter no more than 120 characters.'), (val) => val && val.length < 121),
  dotNumber: number().typeError('Please use numbers with maximum length 9').required(i18n.t('common.fieldRequiredMessage')),
  maintenanceMileage: string().matches(/^\d*(\.\d+)?$/, i18n.t('common.validNumberMessage')),
  address: string().required(i18n.t('common.fieldRequiredMessage')),
  city: string().required(i18n.t('common.fieldRequiredMessage')),
  state: string().required(i18n.t('common.fieldRequiredMessage')),
  zipCode: string().required(i18n.t('common.fieldRequiredMessage')),
  companyPhone: string().required(i18n.t('common.fieldRequiredMessage')),
});
